export const listingsTxt = {
  events: [
    {
      label: 'unborn',
      txt: [ 'prayer for unborn', 'oración por los no nacidos' ],
      date: [ 'January 22', '22 de enero' ]
    },
    {
      label: 'word',
      txt: [ 'word of god', 'Palabra de dios' ],
      date: [ 'January 24', '24 de enero' ]
    },
    {
      label: 'appeal',
      txt: [ "bishop's appeal", 'apelación del obispo' ],
      date: [ '2021', '2021' ]
    },
    {
      label: 'ordinary',
      txt: [ 'ordinary time', 'tiempo ordinario' ],
      date: [ 'Jan 11-May 24', '11 de enero-24 de mayo' ]
    },
    {
      label: 'youthgroup',
      txt: [ 'youth conference', 'conferencia juvenil' ],
      date: [ 'this fall', 'este otoño' ]
    },
    {
      label: 'ffonline',
      txt: [ 'Online Faith Formation', 'formación de fe en línea' ],
      date: [ 'weekly', 'semanal' ]
    },
    {
      label: 'sickday',
      txt: [ 'world sick day', '' ],
      date: [ 'February 11', '11 de febrero' ]
    },
    {
      label: 'latin',
      txt: [ 'latin america collection', 'colección latinoamérica' ],
      date: [ 'January 24', '24 de enero' ]
    },
    {
      label: 'intentions',
      txt: [
        'Intentions of the Holy Father',
        'intenciones del santo padre'
      ],
      date: [ 'January', 'enero' ]
    }
  ],
  items: [
    {
      label: 'unions',
      txt: [
        'bishop on homosexual unions',
        'obispo de las uniones homosexuales'
      ],
      date: [ '', '' ]
    },
    {
      label: 'light',
      txt: [ 'Bishop Strickland book', 'obispo strickland libro' ],
      date: [ '', '' ]
    },
    {
      label: 'faith',
      txt: [
        'faith formation materials',
        'Materiales de formación sacramental'
      ],
      date: [ '', '' ]
    },
    {
      label: 'checklist',
      txt: [ 'mass checklist', 'Lista de verificación masiva' ],
      date: [ 'Updated April 28', 'actualizado el 28 de abril' ]
    },
    { label: 'rosary', txt: [ 'rosary', 'rosario' ], date: [ '', '' ] },
    {
      label: 'thanks',
      txt: [ 'thanks to...', 'gracias a...' ],
      date: [ '', '' ]
    },
    {
      label: 'strickland',
      txt: [ 'Prayer from Bishop', 'oración del obispo' ],
      date: [ '', '' ]
    },
    {
      label: 'letter',
      txt: [
        'Bishop letter on vaccine',
        'carta del obispo sobre la vacuna'
      ],
      date: [ 'April 23', '23 de Abril' ]
    },
    {
      label: 'chaplet',
      txt: [
        'divine mercy chaplet',
        'La coronilla de la Divina Misericordia'
      ],
      date: [ '', '' ]
    },
    {
      label: 'appeal',
      txt: [ "Bishop's Appeal", 'apelación del obispo' ],
      date: [ '', '' ]
    },
    {
      label: 'fatima',
      txt: [ 'fatima movie', 'Película de Fátima' ],
      date: [ '', '' ]
    },
    {
      label: 'unplanned',
      txt: [ '"unplanned" film', 'película no planificada' ],
      date: [ '', '' ]
    },
    {
      label: 'margil',
      txt: [ 'St Margil de Jesus', 'St Margil de Jesus' ],
      date: [ 'Patron Saint of Texas', 'Patrona de Texas' ]
    },
    {
      label: 'indulgence',
      txt: [ 'corona indulgence', 'indulgencia corona' ],
      date: [ '', '' ]
    },
    {
      label: 'corona',
      txt: [ 'epidemic prayer', 'oración epidémica' ],
      date: [ '', '' ]
    },
    {
      label: 'virus',
      txt: [ 'coronavirus novena', 'coronavirus novena' ],
      date: [ '', '' ]
    },
    {
      label: 'duties',
      txt: [ 'duties for Catholics', 'deberes para los catolicos' ],
      date: [ '', '' ]
    },
    {
      label: 'prayer',
      txt: [ 'prayer to st leo', 'Oración a San Leo el Grande' ],
      date: [ '', '' ]
    },
    {
      label: 'memorare',
      txt: [ 'memorare', 'memorare' ],
      date: [ '', '' ]
    }
  ],
  links: [
    {
      label: 'donate',
      txt: [ 'donate online', 'done en línea' ],
      date: [ '', '' ]
    },
    {
      label: 'hotline',
      txt: [ 'nurse hotline', 'línea directa de enfermería' ],
      date: [ '', '' ]
    },
    {
      label: 'resources',
      txt: [ 'virus resources', 'recursos de virus' ],
      date: [ 'St Philip Institute', 'St Philip Institute' ]
    },
    {
      label: 'pandemic',
      txt: [ 'pandemic', 'pandemia' ],
      date: [ '', '' ]
    },
    {
      label: 'links',
      txt: [ 'online resources', 'recursos en línea' ],
      date: [ '', '' ]
    },
    {
      label: 'priests',
      txt: [ 'priests for tomorrow', 'Sacerdotes para Mañana' ],
      date: [ '', '' ]
    },
    {
      label: 'masses',
      txt: [ 'online masses', 'masas en línea' ],
      date: [ '', '' ]
    },
    {
      label: 'diocese',
      txt: [ 'diocese of tyler', 'diocese de tyler' ],
      date: [ '', '' ]
    },
    {
      label: 'vatican',
      txt: [ 'vatican website', 'sitio web del vaticano' ],
      date: [ '', '' ]
    }
  ],
  news: [
    {
      label: 'ruiz',
      txt: [ 'Emanuela Ruiz passed', 'Pasó Emanuela Ruiz' ],
      date: [ "Anita's Mother'", 'Madre de Anita' ]
    },
    {
      label: 'hiring',
      txt: [ 'hiring catechists', 'contratación de catequistas' ],
      date: [ 'immediately', 'inmediatamente' ]
    },
    {
      label: 'wedding',
      txt: [ 'wedding anniversary mass', 'misa de aniversario de bodas' ],
      date: [ 'March 6', '6 de Marzo' ]
    },
    {
      label: 'collection',
      txt: [ 'collection', 'colección' ],
      date: [ 'January 10', '10 de enero' ]
    },
    {
      label: 'reading',
      txt: [ 'readings', 'lecturas' ],
      date: [ 'Jan 17-24', '17-24 de Jan' ]
    },
    {
      label: 'saints',
      txt: [ 'saints & observances', 'santos y observancias' ],
      date: [ 'Jan 17-24', '17-24 de enero' ]
    },
    {
      label: 'pastors',
      txt: [ 'reflections on readings', 'reflexiones sobre lecturas' ],
      date: [ 'January 17', '17 de enero' ]
    },
    {
      label: 'bulletin',
      txt: [ 'church bulletin (pdf)', 'boletín de la iglesia (pdf)' ],
      date: [ 'January 17', '17 de enero' ]
    }
  ]
}
